import { Box, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export default function UtilReceiptFrame() {
  return (
    <Box sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      {/* iPhone Frame */}
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: '#f5f5f7',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* BGE Header Area */}
        <Box sx={{ bgcolor: '#f5f5f7', px: 2, pt: 2.5, pb: 1.5 }}>
          {/* BGE Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
            {/* Stylized BGE swirl icon */}
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <circle cx="14" cy="14" r="10" stroke="#1a8a8a" strokeWidth="1.5" fill="none" opacity="0.6" />
              <circle cx="14" cy="14" r="7" stroke="#6b5ea6" strokeWidth="1.5" fill="none" opacity="0.7" />
              <circle cx="14" cy="14" r="4" stroke="#1a8a8a" strokeWidth="1.5" fill="none" opacity="0.8" />
            </svg>
            <Box>
              <Typography sx={{
                fontSize: '1.125rem',
                fontWeight: 700,
                color: '#1a3a4a',
                lineHeight: 1,
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif'
              }}>
                bge<sup style={{ fontSize: '0.4rem', verticalAlign: 'super' }}>SM</sup>
              </Typography>
              <Typography sx={{
                fontSize: '0.375rem',
                color: '#1a3a4a',
                fontWeight: 500,
                letterSpacing: '0.5px',
                lineHeight: 1.2
              }}>
                AN EXELON COMPANY
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Gradient Bar */}
        <Box sx={{
          height: 4,
          background: 'linear-gradient(to right, #1a5fa8, #1a8a8a, #7ed4c0)',
          width: '100%'
        }} />

        {/* Bill Content */}
        <Box sx={{
          bgcolor: 'white',
          flex: 1,
          px: 2,
          pt: 2.5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          {/* Hello */}
          <Typography sx={{
            fontSize: '0.75rem',
            color: '#1a8a8a',
            mb: 2,
            alignSelf: 'flex-start'
          }}>
            Hello
          </Typography>

          {/* Your Monthly Bill is Ready */}
          <Typography sx={{
            fontSize: '1.125rem',
            fontWeight: 400,
            color: '#1a3a4a',
            textAlign: 'center',
            mb: 3,
            lineHeight: 1.3,
            width: '100%'
          }}>
            Your Monthly Bill is Ready
          </Typography>

          {/* Amount Due */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
            px: 1,
            width: '100%'
          }}>
            <Typography sx={{
              fontSize: '0.75rem',
              fontWeight: 700,
              color: '#1a3a4a'
            }}>
              Amount Due
            </Typography>
            <Typography sx={{
              fontSize: '0.875rem',
              fontWeight: 700,
              color: '#1a3a4a'
            }}>
              $317.23
            </Typography>
          </Box>

          {/* Due Date */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2.5,
            px: 1,
            width: '100%'
          }}>
            <Typography sx={{
              fontSize: '0.75rem',
              fontWeight: 700,
              color: '#1a3a4a'
            }}>
              Due Date
            </Typography>
            <Typography sx={{
              fontSize: '0.875rem',
              fontWeight: 700,
              color: '#1a3a4a'
            }}>
              2/27/2026
            </Typography>
          </Box>

          {/* AutoPay Info */}
          <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 0.75,
            px: 1
          }}>
            <InfoOutlinedIcon sx={{
              fontSize: '0.875rem',
              color: '#6b5ea6',
              mt: 0.125
            }} />
            <Typography sx={{
              fontSize: '0.5rem',
              color: '#4a4a5a',
              lineHeight: 1.5
            }}>
              You are enrolled in AutoPay. Your scheduled payment of{' '}
              <Box component="span" sx={{ fontWeight: 700 }}>$317.23</Box>
              {' '}will be processed on{' '}
              <Box component="span" sx={{ fontWeight: 700 }}>2/27/2026</Box>.
            </Typography>
          </Box>
        </Box>

        {/* "Viewed in Heyy" watermark at bottom */}
        <Box sx={{
          bgcolor: 'white',
          borderTop: '1px solid',
          borderColor: 'grey.200',
          py: 1,
          textAlign: 'center'
        }}>
          <Typography sx={{
            fontSize: '0.5rem',
            color: 'grey.400',
            fontWeight: 500
          }}>
            Viewed in HeyyProperty
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
